import React, {useState} from 'react';

import styles from './Tooltip.module.css'
import {Button} from "../../General/Button/Button.tsx";
import {cn} from "../../../utils/cn.ts";

interface Props {
    question: string
    onConfirm: () => void
    onOpen?: () => void
    onClose?: () => void
}

export const Tooltip: React.FC<Props & React.HTMLAttributes<HTMLDivElement>> = ({children, question, onConfirm, onOpen, onClose, className}) => {
    const [isOpen, setIsOpen] = useState(false)

    return (<>
        <div className={cn(styles.trigger, className)} onClick={() => {
            setIsOpen(true)

            if (onOpen) onOpen()
        }}>
            {children}
            {isOpen && (<div className={styles.tooltip}>
                <div className={styles.title}>
                    {question}
                </div>
                <div className={styles.buttons}>
                    <Button className={styles.btn} type='regular' onClick={(e) => {
                        e.stopPropagation()

                        onConfirm();
                        setIsOpen(false)
                    }}>Да</Button>
                    <Button className={styles.btn} type='regular' onClick={(e) => {
                        e.stopPropagation()

                        setIsOpen(false)

                        if (onClose) onClose()
                    }}>Нет</Button>
                </div>
            </div>)}
        </div>
    </>);
};